import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReceiptCancellationRoutingModule } from './receipt-cancellation-routing.module';
import { ReceiptCancellationComponent } from './receipt-cancellation/receipt-cancellation.component';
import { ReceiptCancellationDialogComponent } from './receipt-cancellation-dialog/receipt-cancellation-dialog.component';
import { ReceiptCancellationlinkComponent } from './receipt-cancellationlink/receipt-cancellationlink.component';
import { ReceiptCancellationlandingComponent } from './receipt-cancellationlanding/receipt-cancellationlanding.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    ReceiptCancellationComponent,
    ReceiptCancellationDialogComponent,
    ReceiptCancellationlinkComponent,
    ReceiptCancellationlandingComponent
  ],
  imports: [
    CommonModule,
    AcademicFormModule,
    ReceiptCancellationRoutingModule,
    MatTableModule,
    MatSortModule,
    // BrowserAnimationsModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatCardModule,
    MatPaginatorModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    SharedModule
    
  ]
})
export class ReceiptCancellationModule { }
